import React from "react";
import { NavLink } from "react-router-dom";

const menuItems = [
  { name: 'Dashboard', icon: '📊', path: '/' },
  { name: 'Ocean Waste Report', icon: '🗑️', path: '/ocean-waste-report' },
  { name: 'Fisherman Network', icon: '🎣', path: '/fisherman-network' },
  { name: 'Cleanup Missions', icon: '♻️', path: '/cleanup' },
  {
    name: 'Help & Support',
    icon: '❓',
    path: 'https://recity.freshdesk.com/support/tickets/new',
    external: true
  },
  // { name: 'Settings', icon: '⚙️', path: '/settings' }
];

const Sidebar = () => {
  return (
    <aside className="w-72 h-full bg-blue-900 bg-gradient-to-b from-blue-900 to-blue-700 text-white shadow-xl flex flex-col relative">
      {/* Logo */}
      <div className="p-6 flex items-center space-x-3 border-b border-blue-400/30" style={{padding:"0.75rem"}}>
        <img src="/sidebar-4.jpg" alt="Recity" className="h-11 w-11 rounded-full border-2 border-blue-200" />
        <span className="text-2xl font-extrabold tracking-tight">Recity</span>
      </div>

      {/* Menu */}
      <nav className="flex-1 p-4" style={{padding:"1rem"}}>
        <ul className="space-y-1">
          {menuItems.map(item => (
            <li key={item.name}>
              {item.external ? (
                <a
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center p-3 rounded-xl transition-all opacity-90 hover:opacity-100 hover:bg-blue-800/60 focus:ring-2 focus:ring-green-400"
                >
                  <span className="text-2xl mr-3">{item.icon}</span>
                  <span>{item.name}</span>
                  <span className="ml-auto text-xs px-2 py-0.5 rounded bg-green-300/80 text-green-900 font-bold uppercase tracking-wide">ext</span>
                </a>
              ) : (
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center p-3 rounded-xl transition-all font-semibold outline-none ${
                      isActive
                        ? 'bg-gradient-to-r from-green-300/90 to-blue-400/80 text-blue-950 shadow-lg'
                        : 'opacity-90 hover:opacity-100 hover:bg-blue-800/60'
                    }`
                  }
                  end={item.path === '/'}
                  tabIndex={0}
                >
                  <span className="text-2xl mr-3">{item.icon}</span>
                  <span>{item.name}</span>
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-5 border-t border-blue-400/30 text-center">
        <p className="text-base font-light">Let's clean the ocean together</p>
        <p className="text-xs mt-1 text-blue-100 tracking-wide font-mono">v1.0.0</p>
      </div>
    </aside>
  );
};

export default Sidebar;
